import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const DashBoardHeader = ({ dashBoardHeader, modifiedHeader }) => {
  const navigate = useNavigate();
  const [preclass, setPreClass] = useState(
    "boxcar-header header-style-v1 header-default"
  );
  const [sideBar, setsideBar] = useState(false);

  useEffect(() => {
    if (dashBoardHeader) {
      setPreClass("boxcar-header header-style-ten");
    } else if (modifiedHeader) {
      setPreClass(
        "boxcar-header header-style-ten style-two inner-header cus-style-1"
      );
    } else {
      setPreClass("boxcar-header header-style-v1 header-default");
    }
  }, [dashBoardHeader, modifiedHeader]);

  return (
    <div>
      <header className={preclass}>
        <div className="header-inner">
          <div className="inner-container">
            <div className="c-box">
              {/* LOGO */}
              <div className="logo-inner">
                <div className="logo">
                  <Link to="/">
                    <img src="images/logo.png" alt="Boxcar" title="Boxcar" />
                  </Link>
                </div>

                {/* SEARCH BOX */}
                <div className="layout-search">
                  <div className="search-box">
                    <svg
                      className="icon"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.29301 1.2876C3.9872 1.2876 1.29431 3.98048 1.29431 7.28631C1.29431 10.5921 3.9872 13.2902 7.29301 13.2902C8.70502 13.2902 10.0036 12.7954 11.03 11.9738L13.5287 14.4712C13.6548 14.5921 13.8232 14.6588 13.9979 14.657C14.1725 14.6552 14.3395 14.5851 14.4631 14.4617C14.5867 14.3382 14.6571 14.1713 14.6591 13.9967C14.6611 13.822 14.5947 13.6535 14.474 13.5272L11.9753 11.0285C12.7976 10.0006 13.293 8.69995 13.293 7.28631C13.293 3.98048 10.5988 1.2876 7.29301 1.2876ZM7.29301 2.62095C9.87824 2.62095 11.9584 4.70108 11.9584 7.28631C11.9584 9.87153 9.87824 11.9569 7.29301 11.9569C4.70778 11.9569 2.62764 9.87153 2.62764 7.28631C2.62764 4.70108 4.70778 2.62095 7.29301 2.62095Z"
                        fill="white"
                      />
                    </svg>
                    <input
                      type="search"
                      placeholder="Search Cars eg. Audi Q7"
                      className="show-search"
                      tabIndex={2}
                    />
                  </div>
                </div>
              </div>

              {/* DESKTOP NAV */}
              <div className="nav-out-bar">
                <nav className="nav main-menu">
                  <ul className="navigation" id="navbar">
                    {[
                      { to: "/Dashboard", label: "Dashboard" },
                      { to: "/AddListing", label: "AddListing" },
                      { to: "/Listing", label: "Listing" },
                      { to: "/MyProfile", label: "MyProfile" },
                      { to: "/", label: "Log Out" },
                    ].map((item) => (
                      <li key={item.to}>
                        <Link to={item.to} className={"active"}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>

              {/* RIGHT SIDE */}
              <div className="right-box">
                <div className="btn">
                  <a href="add-listings.html" className="header-btn-two">
                    Add Listing
                  </a>
                </div>

                {/* HAMBURGER */}
                <div
                  onClick={() => setsideBar(!sideBar)}
                  className="mobile-navigation"
                >
                  <svg
                    width={22}
                    height={11}
                    viewBox="0 0 22 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={22} height={2} fill="white" />
                    <rect y={9} width={22} height={2} fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {sideBar && (
          <div
            id="nav-mobile"
            className="mm-menu mm-menu_offcanvas mm-menu_position-left mm-menu_ mm-menu_theme-black mm-menu_opened"
            aria-hidden="true"
          >
            <div className="mm-panels">
              <div
                id="navbar"
                style={{ backgroundColor: "#050B20", color: "white" }}
                className="mm-panel mm-panel_opened"
              >
                <div
                  style={{ backgroundColor: "#050B20", color: "white" }}
                  className="mm-navbar mm-navbar_sticky"
                >
                  <a className="mm-navbar__title">
                    <span style={{ color: "white" }}>Menu</span>
                  </a>
                </div>
                <ul className="navigation mm-listview">
                  <li className="mm-listitem">
                    <Link
                      style={{ color: "white" }}
                      className="mm-listitem__text"
                      to="/Dashboard"
                      data-discover="true"
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li className="mm-listitem">
                    <Link
                      style={{ color: "white" }}
                      className="mm-listitem__text"
                      to="/AddListing"
                      data-discover="true"
                    >
                      AddListing
                    </Link>
                  </li>
                  <li className="mm-listitem">
                    <Link
                      style={{ color: "white" }}
                      className="mm-listitem__text"
                      to="/Listing"
                      data-discover="true"
                    >
                      Listing
                    </Link>
                  </li>
                  <li className="mm-listitem">
                    <Link
                      style={{ color: "white" }}
                      className="mm-listitem__text"
                      to="/MyProfile"
                      data-discover="true"
                    >
                      MyProfile
                    </Link>
                  </li>
                  <li className="mm-listitem">
                    <Link
                      style={{ color: "white" }}
                      className="mm-listitem__text"
                      to="/"
                      data-discover="true"
                    >
                      Log Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* SEARCH POPUP */}
        <div className="search-popup">
          <span className="search-back-drop" />
          <button className="close-search">
            <span className="fa fa-times" />
          </button>
        </div>
      </header>
    </div>
  );
};

export default DashBoardHeader;
